export default {
  SettingBaseDataConfig: {
    channel: 'System Channel',
    logo: 'System ID',

    table: {
      channel: 'System Channel',
      logo: 'System ID',
      name: 'Platform Application Name',
      type: 'Platform Application Type',
      authorizeAddress: 'Authorization address',
      otherAddress: 'Other Addresses',
      apiAddress: 'API Service Address',
      callbackAddress: 'Callback Address',
      AuthorizeAccount: 'Authorized Account',
      certificateTraffic: 'Certificate Traffic',
      openPlatform: 'Open Platform Address',
      account: 'Account',
      remark: 'Note',
    },

    addAndEdit: {
      editValue: 'Edit Value Set',
      addValue: 'Add Value Set',
      msg: 'Application Information',
      channel: 'System Channel',
      logo: 'Application ID',
      applicationName: 'Platform Application Name',
      applicationType: 'Platform Application Type',
      authorize: 'Authorization Address',
      otherAddress: 'Other Addresses',
      api: 'API Service Address',
      callbackAddress: 'Callback Address',
      certificate: 'Certificate Traffic',
      openPlatform: 'Open Platform Address',
      account: 'Account',
      remark: 'Note',
      callbackAddressText: 'Please enter callback address',
      authorizeAccount: 'Authorized account',
      applicationNameText: 'Please enter the platform application name',
      applicationTypeText: 'Please enter platform application type',
      app_keyText: 'Please enter app_key',
      app_secretText: 'Please enter app_secret',
      channelText: 'Please select system channel',
      systemText: 'Please enter system ID',
      valueSet: 'Value Set'
    }
  }
};
